// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"MarketingStockCatalogComponent_sliderWrapper__VCMpY","stockImage":"MarketingStockCatalogComponent_stockImage__6cJDQ"};